import React from 'react';
import './Services.css';
import logo from '../Images/Logo_Invis.png';
import yachtVideo from '../Images/yacht.mp4';
import yachtVideo2 from '../Images/yacht2.mp4';


import serviceImage from '../Images/Our Services.png';
import slideImage1 from '../Images/Services/1.png';
import slideImage2 from '../Images/Services/2.png';
import { useState } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import { FiMail } from 'react-icons/fi';
import Navbar from '../Components/Navbar/Navbar';
import Footer from '../Components/Footer/Footer';
import { Link } from 'react-router-dom';
import { getServicesInDisplayOrder } from './serviceData';


//countries
import anu from '../Images/Countries/anu.png';
import grenada from '../Images/Countries/grenada.png';
import stLucia from '../Images/Countries/st lucia.png';
import stThomas from '../Images/Countries/st thomas.png';
import tt from '../Images/Countries/tt.png';
import stMaarteen from '../Images/Countries/St Maarten.png'


//images
import AntarticYacht from '../Images/ServicesGrid/Antarctic-yacht-expedition2.jpg';
import Helicopter from '../Images/ServicesGrid/helicopter.jpg';
import NickYacht from '../Images/ServicesGrid/Nick-with-ICON-yachts-team-member-ICON-shipyard-Holland.jpg';
import PlasticBottle from '../Images/ServicesGrid/plastic-bottle-ocean.jpg';
import UBoatSub from '../Images/ServicesGrid/U-Boat-Worx-private-submarine-The-Super-Yacht-Sub-3-C-Joachim-Blomme.jpg';
import Voyage from '../Images/ServicesGrid/Voyage.jpg';
import ConciergeServices from '../Images/Services/Concierge Services _ Flight Bookings _ VIP Transport.png';

import ServicesBright from '../Images/Services/BannerBright.jpg';
import ServicesNight from '../Images/Services/BannerEvening.jpg';

import InteractiveMap from './InteractiveMap';

const slides = [
  {
    image: slideImage1,
    title: 'Title 1',
    description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit.'
  },
  {
    image: slideImage2,
    title: 'Title 2',
    description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit.'
  },
  
]

  const countryData = getServicesInDisplayOrder();





function Services() {

  const [index, setIndex] = useState(0);

  const prevSlide = () => {
    setIndex((index - 1 + slides.length) % slides.length);
  };

  const nextSlide = () => {
    setIndex((index + 1) % slides.length);
  };
  

  const [heroImage] = useState(()=>
  
    Math.random()  < 0.5 ? ServicesBright: ServicesNight
    
  );
  // console.log(heroImage);
  return (

    
    <div className="services-container">
      
      <Navbar/>
   

      <div className="services-hero">
        {/* <video autoPlay loop muted className="hero-video" controls>
          <source src={yachtVideo2} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        <img
          src={heroImage}
          alt="Antigua & Barbuda coastline"
          className="services-hero-image"
        />
        <div className="services-hero-overlay">
          <section className="services-header">
            <h1>Our Services in Antigua and Barbuda</h1>
            <p>Comprehensive Port Agency Services delivered alongside dependable Shoreside and Technical support.</p>
          </section>
        </div>
      </div>

      
    
      
      {/* # countries */}
      {/* Country Grid */}
          <section className="services-grid">
          {countryData.map((country) => (
            <Link
              className="services-card"
              key={country.name}
              to={`/services/${country.slug}`}
              aria-label={`Learn more about ${country.name}`}
            >
              <img src={country.image} alt={country.name} />
              <div className="services-overlay">
                <h3>{country.name}</h3>
                <p>Learn more</p>
              </div>
            </Link>
          ))}
    </section>
    <section className="services-cta-explore">
      <div className="services-cta-box">
        <h3>Speak with our team today!</h3>
        <p>Your next adventure begins here.</p>
      </div>
      <a href="/connect" className="explore-link">EXPLORE</a>
    </section>


        <Footer/>
      
    </div>
  );
}

export default Services;
